export type VerificationStatusType = {
  pdfData: string;
  status: string;
  fileNumber: string;
  officeName: string;
  letterType: string;
  updatedBy: string;
  updatedDate: string;
};

export type AvlVerificationStatusType = {
  LetterType: string;
  AgentName: string;
  AgentAddressLine1: string;
  AgentAddressLine2: string;
  OfficeId?: number;
  OfficeName: string;
  CreatedDate: string;
  CreatedBy: string;
  Document: AvlDocument;
};

export type AvlDocument = {
  Content: string;
  Encoding: string;
  MimeType: string;
  Name: string;
};

export enum TransactionStatusEnum {
  Created = 'Created',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Pending = 'Pending',
  AwaitingUserAction = 'AwaitingUserAction',
  Error = 'Error',
  Failed = 'Failed',
  UserCancelled = 'UserCancelled',
}

export interface IdentityVerificationResponse {
  fileId: string;
  transactionId: string;
  transactionStatus:
    | TransactionStatusEnum.Created
    | TransactionStatusEnum.Cancelled
    | TransactionStatusEnum.Completed
    | TransactionStatusEnum.Pending
    | TransactionStatusEnum.AwaitingUserAction
    | TransactionStatusEnum.Error
    | TransactionStatusEnum.UserCancelled;
  referenceId: string;
  data: {
    captureUrl: string;
  };
}
